module.exports = __webpack_public_path__ + "static/media/foto_1.f93962e3.png";